import type { PeriodStatementBase, UnsplitFigures } from '../types/dealerFundStatementPeriod.types';
import { sumAtScale } from './sumAtScale';

export interface BalanceUnsplitShares {
    opening: UnsplitFigures;
    closing: UnsplitFigures;
}

const negate = (amount: string): string => (amount.startsWith('-') ? amount.slice(1) : `-${amount}`);

export const balanceUnsplitShares = (
    statement: Pick<PeriodStatementBase, 'unsplit' | 'balanceUnsplit'>,
): BalanceUnsplitShares => ({
    closing: statement.balanceUnsplit,
    opening: {
        postings: statement.balanceUnsplit.postings - statement.unsplit.postings,
        gross: sumAtScale([statement.balanceUnsplit.gross, negate(statement.unsplit.gross)], 2),
    },
});
